<p class="heading">
    <strong *ngIf="id">{{'pages.branches.deliveryTypeDialog.editHeading' | translate}}</strong>
    <strong *ngIf="!id">{{'pages.branches.deliveryTypeDialog.addHeading' | translate}}</strong><mat-icon
        mat-dialog-close>close</mat-icon>
</p>
<p class="heading redcolor">
    <strong *ngIf="selectedTabindex == 1">{{'pages.branches.deliveryTypeDialog.addHeading1' | translate}}</strong>
</p>
<mat-tab-group mat-align-tabs="center" (selectedTabChange)="tabChanged($event)">
    <mat-tab label="{{'pages.branches.deliveryTypeDialog.input.bundled' | translate}}" [disabled]="false">
        <form [formGroup]="bundledForm" (ngSubmit)="submitForm()">
            <p class="topAndmargin">{{'pages.branches.deliveryTypeDialog.input.deliverOn' | translate}}</p>
            <mat-tab-group mat-align-tabs="center">
                <mat-tab label="{{'pages.branches.deliveryTypeDialog.input.mon' | translate}}"
                    [labelClass]="bundledForm.controls['monday'].invalid ? 'invalid-form' : ''" [disabled]="weekdays">
                    <app-bundle-time-slot formControlName="monday"></app-bundle-time-slot>
                </mat-tab>
                <mat-tab label="{{'pages.branches.deliveryTypeDialog.input.tue' | translate}}"
                    [labelClass]="bundledForm.controls['tuesday'].invalid ? 'invalid-form' : ''" [disabled]="weekdays">
                    <app-bundle-time-slot formControlName="tuesday"></app-bundle-time-slot>
                </mat-tab>
                <mat-tab label="{{'pages.branches.deliveryTypeDialog.input.wed' | translate}}"
                    [labelClass]="bundledForm.controls['wednesday'].invalid ? 'invalid-form' : ''"
                    [disabled]="weekdays">
                    <app-bundle-time-slot formControlName="wednesday"></app-bundle-time-slot>
                </mat-tab>
                <mat-tab label="{{'pages.branches.deliveryTypeDialog.input.thu' | translate}}"
                    [labelClass]="bundledForm.controls['thursday'].invalid ? 'invalid-form' : ''" [disabled]="weekdays">
                    <app-bundle-time-slot formControlName="thursday"></app-bundle-time-slot>
                </mat-tab>
                <mat-tab label="{{'pages.branches.deliveryTypeDialog.input.fri' | translate}}"
                    [labelClass]="bundledForm.controls['friday'].invalid ? 'invalid-form' : ''" [disabled]="weekdays">
                    <app-bundle-time-slot formControlName="friday"></app-bundle-time-slot>
                </mat-tab>
                <mat-tab label="{{'pages.branches.deliveryTypeDialog.input.sat' | translate}}"
                    [labelClass]="bundledForm.controls['saturday'].invalid ? 'invalid-form' : ''" [disabled]="weekdays">
                    <app-bundle-time-slot formControlName="saturday"></app-bundle-time-slot>
                </mat-tab>
                <mat-tab label="{{'pages.branches.deliveryTypeDialog.input.sun' | translate}}"
                    [labelClass]="bundledForm.controls['sunday'].invalid ? 'invalid-form' : ''" [disabled]="weekdays">
                    <app-bundle-time-slot formControlName="sunday"></app-bundle-time-slot>
                </mat-tab>
            </mat-tab-group>
            <button class="fill-button" [disabled]="!bundledForm.valid" mat-flat-button> {{'pages.common.buttons.save' |
                translate}} </button>
            <p>{{'pages.branches.deliveryTypeDialog.deliveryTypeNote' | translate}}</p>
        </form>
    </mat-tab>
    <mat-tab label="{{'pages.branches.deliveryTypeDialog.input.onDemand' | translate}}" [disabled]="false">
        <form [formGroup]="onDemandForm" (ngSubmit)="submitForm('onDemandForm')">
            <div class="mt-3">
                <app-slot-interval-select formControlName="slotinterval" (intervalChange)="onValueChange()"
                    [placeholderTranslationKey]="'pages.branches.timeSlotDialog.input.deactivated'"></app-slot-interval-select>
            </div>
            <div class="row topAndmargin">
                <div class="col">
                    <label>{{'pages.branches.deliveryTypeDialog.input.maximumOrders' | translate}}</label>
                    <input type="number" formControlName="maximumorders" min="1" max="100"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'') && this.value > 100 ? '' : this.value && this.value == 0?'':this.value"
                        class="form-control" [attr.disabled]="!onDemandForm.controls['slotinterval'].value ? '' : null">
                    <div class="invalid-feedback"
                        *ngIf="onDemandForm.controls['maximumorders'].invalid && (onDemandForm.controls['maximumorders'].dirty || onDemandForm.controls['maximumorders'].touched)">
                        {{'pages.branches.deliveryTypeDialog.inputValidation.maximumOrders.required' | translate}}</div>
                </div>
                <div class="col">
                    <label>{{'pages.branches.deliveryTypeDialog.input.ondemandcutoff' | translate}}</label>
                    <div class="cutoff-hours">
                        <div>
                            <input type="number" formControlName="ondemandcutoff" min="1" max="1440"
                                oninput="this.value=this.value.replace(/[^0-9]/g,'') && this.value && this.value == 0?'':this.value"
                                class="form-control"
                                [attr.disabled]="!onDemandForm.controls['slotinterval'].value ? '' : null">
                            <div class="invalid-feedback"
                                *ngIf="onDemandForm.controls['ondemandcutoff'].invalid && (onDemandForm.controls['ondemandcutoff'].dirty || onDemandForm.controls['ondemandcutoff'].touched)">
                                {{'pages.branches.deliveryTypeDialog.inputValidation.ondemandcutoff.required' |
                                translate}}</div>
                        </div>
                        <div>
                            <label>{{'pages.branches.deliveryTypeDialog.input.minutusBefore' | translate}}</label>
                        </div>
                    </div>

                </div>
            </div>
            <button class="fill-button" mat-flat-button> {{'pages.common.buttons.save' | translate}} </button>
            <p>{{'pages.branches.deliveryTypeDialog.deliveryTypeNote' | translate}}</p>
        </form>
    </mat-tab>
</mat-tab-group>